import type { DiTypes } from "@iot-platform/core";

export const weatherTypes = Object.seal({
    repositories: {
        WeatherRepository: Symbol.for("WeatherRepository"),
    },
} satisfies DiTypes);
